import {
	FileSpreadsheet,
	FilePlus,
	ClipboardCheckIcon,
	FileText,
	FileImage,
	FileCode,
	FileType2,
	File,
	FileVideo,
	Box,
} from "lucide-react";
import { FileTypeWithDocumentType } from "@/lib/utils/file-utils";

const colorMap = {
	success: "green",
	error: "red",
	warning: "yellow",
	info: "blue",
};

/**
 * Named this "...Component" to avoid conflict with:
 * import { FileIcon } from "lucide-react";
 */
export const FileIconComponent: React.FC<{
	fileType: FileTypeWithDocumentType;
	size?: number;
	color?: "success" | "error" | "warning" | "info" | undefined;
}> = ({ fileType, size = 20, color }) => {
	const colorToUse = color ? colorMap[color] : undefined;
	switch (fileType) {
		case "kv":
			return <FileSpreadsheet size={size} color={colorToUse} />;
		case "ls":
			return <ClipboardCheckIcon size={size} color={colorToUse} />;
		case "gs":
			return <FilePlus size={size} color={colorToUse} />;
		case "pdf":
			return <FileText size={size} color={colorToUse} />;
		case "img":
			return <FileImage size={size} color={colorToUse} />;
		case "xml":
			return <FileCode size={size} color={colorToUse} />;
		case "txt":
			return <FileType2 size={size} color={colorToUse} />;
		case "video":
			return <FileVideo size={size} color={colorToUse} />;
		case "3d":
			return <Box size={size} color={colorToUse} />;
		default:
			return <File size={size} color={colorToUse} />;
	}
};
